import styles from './index.module.css'
import { forwardRef } from 'react'
import { aboutArt, aboutComments, aboutDashboard, aboutMe, aboutWaterDB } from '../../constants.tsx'
import mailSVG from '../../assets/mail-svgrepo-com.svg'


export const GlassModalFromMenu = forwardRef<HTMLDivElement>((_, ref) => {
  function openLink(link: string) {
    window.open(link)
  }

  return (
    <div className={styles.glass_container} ref={ref}>
      <div className={styles.glass_items}>
        <div className={styles.glass_photo}></div>
        <div className={styles.glass_text_block}>
          <div className={styles.text_items}>
             <span className={styles.text_name}>VLAD PASHKOVSKY</span>
             <span className={styles.text_profession}>Full-Stack Developer</span>
            <span className={styles.text_contact}>
              <img src={mailSVG} alt="" />
              <a href="mailto:v.v.pashkovsky@gmail.com">
                <span>v.v.pashkovsky@gmail.com</span>
              </a>
            </span>
            <div className={styles.text_about}>{aboutMe}</div>
          </div>
        </div>
      </div>
    </div>
  )
})

